import {
  ACTIVITY_ICON_NAME,
  LESSON_ACTIVITY_TYPE,
} from "@plugins/common/constant/resource.constant.ts";
export function useActivityIcon() {
  const getActivityIconName = (activity) => {
    return getActivityIconNameByTypeAndOptional(activity.type, activity.optional);
  };
  const getActivityIconNameByTypeAndOptional = (type, optional) => {
    if (type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
      return optional ? ACTIVITY_ICON_NAME.QUIZ_OPTIONAL : ACTIVITY_ICON_NAME.QUIZ_PAGE;
    } else {
      return optional ? ACTIVITY_ICON_NAME.PAGE_OPTIONAL : ACTIVITY_ICON_NAME.PAGE;
    }
  };
  const getActivityCompletedDisabledIconName = (activity) => {
    if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
      return activity.optional
        ? ACTIVITY_ICON_NAME.QUIZ_COMPLETED_DISABLED_OPTIONAL
        : ACTIVITY_ICON_NAME.QUIZ_COMPLETED_DISABLED;
    } else {
      return activity.optional
        ? ACTIVITY_ICON_NAME.PAGE_COMPLETED_DISABLED_OPTIONAL
        : ACTIVITY_ICON_NAME.PAGE_COMPLETED_DISABLED;
    }
  };
  const getActivityCompletedIconName = (activity) => {
    if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
      return ACTIVITY_ICON_NAME.QUIZ_COMPLETED;
    } else {
      return ACTIVITY_ICON_NAME.PAGE_COMPLETED;
    }
  };
  const getActivityNoAccessIconName = (activity) => {
    if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
      return ACTIVITY_ICON_NAME.QUIZ_NO_ACCESS;
    } else {
      return ACTIVITY_ICON_NAME.PAGE_NO_ACCESS;
    }
  };
  const getActivityRestrictedIconName = (activity) => {
    if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
      return ACTIVITY_ICON_NAME.QUIZ_RESTRICTED;
    } else {
      return ACTIVITY_ICON_NAME.PAGE_RESTRICTED;
    }
  };
  const getActivityPrerequisiteIconName = (activity) => {
    if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
      return ACTIVITY_ICON_NAME.QUIZ_PAGE_PREREQ;
    } else {
      return ACTIVITY_ICON_NAME.PAGE_PREREQ;
    }
  };
  const getActivityOptionalIconName = (activity) => {
    if (activity.type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
      return ACTIVITY_ICON_NAME.QUIZ_OPTIONAL;
    } else {
      return ACTIVITY_ICON_NAME.PAGE_OPTIONAL;
    }
  };
  const getActivityIconNameByTypeAndOptionalAndDisabled = (type, optional, disabled) => {
    if (disabled) {
      if (type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
        return optional
          ? ACTIVITY_ICON_NAME.QUIZ_DISABLED_OPTIONAL
          : ACTIVITY_ICON_NAME.QUIZ_DISABLED;
      } else {
        return optional
          ? ACTIVITY_ICON_NAME.PAGE_DISABLED_OPTIONAL
          : ACTIVITY_ICON_NAME.PAGE_DISABLED;
      }
    } else {
      return getActivityIconNameByTypeAndOptional(type, optional);
    }
  };

  return {
    getActivityIconName,
    getActivityIconNameByTypeAndOptional,
    getActivityCompletedDisabledIconName,
    getActivityCompletedIconName,
    getActivityNoAccessIconName,
    getActivityRestrictedIconName,
    getActivityPrerequisiteIconName,
    getActivityOptionalIconName,
    getActivityIconNameByTypeAndOptionalAndDisabled,
  };
}
// end of file
